import React from 'react';

import { FlattenedTreeItem, FolderTreeItemKind } from 'stores/Folders/types';

interface TreeDragState {
  canReorder: boolean;
  activeRow: FlattenedTreeItem | null;
}

export const FolderDragContext = React.createContext<TreeDragState>({ canReorder: false, activeRow: null });

export const useFolderDrag = (): TreeDragState => React.useContext(FolderDragContext);

// A row outside the dragged row's sibling group can't be dropped onto, so it dims
// mid-drag rather than leaving the user to discover that by trying.
export const useIsBlockedDropTarget = (uuid: string, kind: FolderTreeItemKind, parentUuid: string | null): boolean => {
  const { activeRow } = useFolderDrag();
  if (!activeRow || activeRow.uuid === uuid) return false;
  return activeRow.kind !== kind || activeRow.parentUuid !== parentUuid;
};
